/**
 * SIMPS Drink Lab — recipes.js
 * Launch recipe registry, IDs frozen per spec §11.
 *
 * PRODUCTION SAFETY GATE (spec §11, §63):
 * The recommendation engine's hard filter only allows recipes whose
 * testingStatus is 'approved' to appear outside of ?drinkLabDebug=true.
 * All 34 launch recipes were flipped to 'approved' by merchant decision on
 * 2026-08-11 for live testing. DL-035–DL-071 (Expansion Pack v1 + v2, added
 * 2026-08-11) start life as 'untested' per the packs' own instructions and
 * must stay that way until SIMPS has physically taste-tested them. If a
 * specific recipe is later found inaccurate or needs to be pulled pending
 * SIMPS confirmation, reset that recipe's testingStatus to 'untested'
 * individually — it will then only be visible again via
 * ?drinkLabDebug=true on the dev theme.
 *
 * Every hero/upgrade product key below resolves against
 * window.DrinkLab.SHOPIFY_PRODUCTS — real retail products only, with two
 * flagged exceptions in the expansion pack (DL-041 'orange_soda', DL-043
 * 'cherry') that don't currently resolve to a real syrup product and so
 * stay invisible everywhere, even in debug, until that's fixed.
 */
window.DrinkLab = window.DrinkLab || {};

window.DrinkLab.RECIPES = [].concat(
  window.DrinkLab.RECIPES_PART1 || [],
  window.DrinkLab.RECIPES_PART2 || []
);
